function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;

  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();

  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({
      left: event.target.offsetLeft,
    });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  if (zoomOnHoverScript) {
    const newScriptTag = document.createElement('script');
    newScriptTag.src = zoomOnHoverScript.src;
    zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  document.querySelectorAll(`[data-section="${event.detail.sectionId}"]`).forEach((element) => {
    element.remove();
    document.body.classList.remove('overflow-hidden');
  });
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());

document.addEventListener('shopify:section:select', () => hideProductModal());

document.addEventListener('shopify:section:deselect', () => hideProductModal());

document.addEventListener('shopify:inspector:activate', () => hideProductModal());

document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());

console.log('theme-editor.js is loaded'); // Debug to confirm script is running

document.addEventListener('DOMContentLoaded', () => {
  const loginTriggers = document.querySelectorAll('.login-popup-trigger');
  const loginPopup = document.getElementById('login-popup');
  const closeButtons = document.querySelectorAll('.login-popup__close'); // Use querySelectorAll

  if (loginTriggers.length > 0 && loginPopup && closeButtons.length > 0) {
    // Open popup
    loginTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        loginPopup.style.display = 'flex';
      });
    });

    // Close popup - Attach listener to all close buttons
    closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        loginPopup.style.display = 'none';
      });
    });

    // Close popup when clicking outside
    loginPopup.addEventListener('click', (e) => {
      if (e.target === loginPopup) {
        loginPopup.style.display = 'none';
      }
    });
  }
});

// ** THE FIX IS HERE **
// Wait for the entire page and all scripts to load before running.
// Also, safely check if the function and variable exist to prevent errors.
window.addEventListener('load', () => {
  if (typeof updateHeaderState === 'function') {
    updateHeaderState();
  }
  if (typeof headerWrapper !== 'undefined' && headerWrapper) {
    headerWrapper.style.visibility = 'visible';
  }
});